import "./App.css";
import { Container } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import styled from "styled-components";

const StyledGrid = styled(Grid)``;

const Header = styled(Grid)`
  background-color: #d8ac3a;
  height: 100px;
  align-items: center;
  justify-content: space-between;
`;

const Bottom = styled(Grid)`
  background-color: "#D8AC3A";
  position: "absolute";
  bottom: 0;
  height: 100;
`;

function App() {
  return (
    <Container fixed>
      <StyledGrid container spacing={2}>
        <Header
          item
          xs={12}
          style={{
            display: "flex",
            padding: 16,
          }}
        >
          <div
            style={{
              width: 30,
              height: 30,
              borderRadius: 15,
              marginRight: 16,
              backgroundColor: "#7C5B06",
            }}
          />
          <div
            style={{
              width: 30,
              height: 30,
              borderRadius: 15,
              marginRight: 16,
              backgroundColor: "white",
            }}
          />
          <div
            style={{
              width: 30,
              height: 30,
              borderRadius: 15,
              backgroundColor: "#7C5B06",
            }}
          />
        </Header>
        <Grid item xs={6} style={{ padding: 32 }}>
          <div style={{ fontSize: 60, color: "#7B7B7B", marginBottom: 16 }}>
            심플한 탁상시계
          </div>
          <div>
            <div style={{ color: "#A24040", fontSize: 60 }}>Digital</div>
            <div style={{ fontSize: 80 }}>YOUNG:</div>
            <div style={{ fontSize: 80 }}>CLOCK</div>
          </div>
        </Grid>
        <Grid item xs={6} style={{ display: 'flex', alignItems: 'center'}}>
          <img src="img_screenshot_1.png" style={{ width: 500, objectFit: 'contains'}}/>
        </Grid>
      </StyledGrid>
    </Container>
  );
}

export default App;
